export {
  DesktopDisplayControl,
  DesktopDisplayControlMenuListTarget,
} from "./displayControl.desktop";
export { MobileDisplayControl } from "./displayControl.mobile";
